@use "u";

@layer components {
    .content {
        $top: var(--pop-top, 0);
        $left: var(--pop-left, 0);
        $width: var(--pop-width, 0);
        $height: var(--pop-height, 0);

        position: fixed;

        &.top {
            top: $top;
            left: calc($left + ($width / 2));
        }

        &.bottom {
            top: calc($top + $height);
            left: calc($left + ($width / 2));
        }

        &.left {
            top: calc($top + ($height / 2));
            left: $left;
        }

        &.right {
            top: calc($top + ($height / 2));
            left: calc($left + $width);
        }

        &.center {
            top: calc($top + ($height / 2));
            left: calc($left + ($width / 2));
        }
    }
}
